import request from '@ps/utils/request'
import { AxiosPromise } from 'axios'

export interface VideoToProjectParams {
  pid: number
  asset_id: string // 因为资产库的id 超过了int的范围，所以这里用string
  path_v: string
  path_a: string
  path_origin: string // 原始视频地址， 因为有些视频是从资产库中获取，资产库的地址会过期，所以需要记录原始地址
  format: 'mp4' | 'ts' // 不传默认为 mp4，传 ts 表示使用 ts 格式
  from: number // 1 公共资源库 2 新公共资源库 3 用户资源库
}

// http://playable.dev.com:8067//?doc=playsmart/playturbo%2fhandler%2fplaysmart%2feditor_video.go
export function addVideoToProject(
  data: Partial<VideoToProjectParams>,
): AxiosPromise {
  return request({
    url: '/ps/editor/video/add',
    method: 'post',
    data: data,
  })
}

export function cutVideoAndAddToProject(data: {
  pid: number
  url: string
  stime: number
  etime: number
  path_v: string
  path_a: string
}): AxiosPromise {
  return request({
    url: '/ps/editor/video/cut',
    method: 'post',
    data: data,
  })
}
